// Phase 17 · AI Insights card for the Management Dashboard
import { useEffect, useState } from "react";
import { Sparkles } from "lucide-react";
import { api } from "@/lib/api";

export default function AIInsightsCard() {
  const [summary, setSummary] = useState(null);
  const [anomalyCount, setAnomalyCount] = useState(0);
  useEffect(() => {
    (async () => {
      try {
        const [s, a] = await Promise.all([
          api.get("/ai/summaries/mine?period_type=daily"),
          api.get("/ai/anomalies?page_size=1"),
        ]);
        setSummary(s.data);
        setAnomalyCount(a.data?.total || 0);
      } catch (e) {}
    })();
  }, []);

  return (
    <div className="bg-gradient-to-br from-fuchsia-50 to-indigo-50 border border-fuchsia-200 rounded-xl p-4 space-y-2"
         data-testid="ai-insights-card">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2 text-sm font-semibold text-[#6b21a8]">
          <Sparkles className="w-4 h-4 text-[#E5197F]" /> AI insight for {summary?.period_key || "today"}
        </div>
        {anomalyCount > 0 && (
          <span className="text-[11px] px-2 py-0.5 rounded-full bg-rose-100 text-rose-700 font-semibold" data-testid="ai-anomaly-badge">
            {anomalyCount} anomaly{anomalyCount === 1 ? "" : "ies"}
          </span>
        )}
      </div>
      <p className="text-sm text-neutral-800 leading-relaxed" data-testid="ai-summary-text">
        {summary?.text || "Your AI summary will appear here after tonight's job runs — or you can trigger a preview via the AI Insights page."}
      </p>
    </div>
  );
}
